// Environment configuration for mock data

/**
 * Check if we should use mock data
 * @returns {boolean}
 */
export function useMockData() {
  // Check if running in development mode
  const isDev = import.meta.env.DEV;
  
  // Check if there's a query parameter to force mock data
  const urlParams = new URLSearchParams(window.location.search);
  const forceMock = urlParams.get('mock') === 'true';
  
  // Use mock data if in dev mode or forced via query param
  return isDev || forceMock;
}
